import { cn } from '@/components/ui/cn'

interface SenseGlossLineProps {
  gloss?: string
  className?: string
}

export function SenseGlossLine({ gloss, className }: SenseGlossLineProps) {
  if (!gloss) {
    return null
  }

  return (
    <p
      className={cn('mt-2 text-sm text-muted-foreground', className)}
      data-testid="sense-gloss"
    >
      {gloss}
    </p>
  )
}
